var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6 offset-3"},[_vm._v(" Ошибка, такой страницы нет! Вернитесь на "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("главную")]),_vm._v(" ! ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }